<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <el-date-picker
          v-model="date"
          type="daterange"
          class="picker"
          clearable
          @change="event().selectDate($event)"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-input
          class="input"
          v-model="body.word"
          clearable
          @change="event().search()"
          suffix-icon="el-icon-search"
          placeholder="请输入账号"/>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      class="table"
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { ExchangeDate } from '@/jslib/utils'
import { getLogList } from '@/api/authority'
export default {
  data() {
    return {
      date: '',
      body: {
        pageSize: 10,
        pageIndex: 1,
        startTime: '',
        endTime: '',
        word: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'createTime',
            label: '操作时间'
          },
          {
            prop: 'account',
            label: '操作账号'
          },
          {
            prop: 'name',
            label: '身份名称'
          },
          {
            prop: 'action',
            label: '操作内容'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      }
    }
  },
  created() {
    this.network().getLogList()
  },
  methods: {
    event() {
      return {
        selectDate: (e) => {
          if (e == null) {
            this.body.endTime = ''
            this.body.startTime = ''
          } else {
            this.body.startTime = ExchangeDate(this.date[0])
            this.body.endTime = ExchangeDate(this.date[1])
          }
          this.network().getLogList()
        },
        search: () => {
          this.network().getLogList()
        }
      }
    },
    network() {
      return {
        getLogList: async() => {
          const { data } = await getLogList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getLogList()
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
  }
  .left{
    display: flex;
    .picker{
      flex: 3;
    }
    .input{
      flex: 2;
      margin-left: 30px;
    }
  }
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}
</style>
